import ButtonGroup from "react-bootstrap/ButtonGroup";
import { NavLink } from "react-router-dom";

function SubNavigation() {
  const toggleSideBar = () => {
    let label = document.createElement("label");
    label.setAttribute("for", "side-toggle");
    document.body.appendChild(label);
    label.click();
    document.body.removeChild(label);
  };
  return (
    <nav role="navigation" aria-label="Map type selection">
      <ButtonGroup className="sub-nav" onClick={toggleSideBar}>
        <NavLink
          className={({ isActive }) =>
            "btn btn-default " + (isActive ? "active" : "")
          }
          to="/crossings"
          aria-label="View all crossings"
        >
          <span className="d-none d-lg-block">All Crossings</span>
          <i className="fa-regular fa-bicycle d-lg-none" aria-hidden="true"></i>
        </NavLink>
        <NavLink
          className={({ isActive }) =>
            "btn btn-default " + (isActive ? "active" : "")
          }
          to="/cameras"
          aria-label="View traffic cameras"
        >
          <span className="d-none d-lg-block">Cameras</span>
          <i className="fa-regular fa-camera d-lg-none" aria-hidden="true"></i>
        </NavLink>
        <NavLink
          className={({ isActive }) =>
            "btn btn-default " + (isActive ? "active" : "")
          }
          to="/"
          aria-label="View road closures"
        >
          <span className="d-none d-lg-block">Closures</span>
          <i
            className="fa-regular fa-times-circle d-lg-none"
            aria-hidden="true"
          ></i>
        </NavLink>
      </ButtonGroup>
    </nav>
  );
}

export default SubNavigation;
